import SliderTwo from "../../../../assets/images/slide-two.png";
import SliderThree from "../../../../assets/images/slide-three.png";
import SliderFour from "../../../../assets/images/slide-four.png";

export var SliderData = [
  {
    Img: SliderFour,
    name: "Livia Bator",
    Roll: "CEO",
  },
  {
    Img: SliderTwo,
    name: "Randy Press",
    Roll: "Director",
  },
  {
    Img: SliderThree,
    name: "Workman",
    Roll: "Designer",
  },
  {
    Img: SliderTwo,
    name: "Livia Bator",
    Roll: "CEO",
  },
];
